import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex-1" }
const _hoisted_2 = { class: "font-semibold" }
const _hoisted_3 = ["href"]

import { inject } from 'vue'
import { useTheme } from '../../utils/useTheme'
import { useViewAs } from '../../utils/useViewAs'


export default /*@__PURE__*/_defineComponent({
  __name: 'ViewAsBanner',
  setup(__props) {

const theme = inject('theme', useTheme())
const { viewAsMode, viewAsLabel, dashboardWithoutViewAs } = useViewAs()

return (_ctx: any,_cache: any) => {
  return (_unref(viewAsMode))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([
      _unref(theme).isDark.value ? 'bg-amber-900/40 border-amber-700/60 text-amber-200' : 'bg-amber-100 border-amber-300 text-amber-900',
      'border-b px-6 py-2.5 text-sm flex items-center gap-3'
    ])
      }, [
        _cache[3] || (_cache[3] = _createElementVNode("svg", {
          class: "w-4 h-4 shrink-0",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          viewBox: "0 0 24 24"
        }, [
          _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }),
          _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_1, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "font-semibold" }, "Preview mode:", -1)),
          _cache[1] || (_cache[1] = _createTextVNode(" viewing as ")),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(viewAsLabel)), 1),
          _cache[2] || (_cache[2] = _createTextVNode(" — write actions hidden "))
        ]),
        _createElementVNode("a", {
          href: _unref(dashboardWithoutViewAs),
          class: _normalizeClass([_unref(theme).isDark.value ? 'text-amber-200 hover:text-amber-100' : 'text-amber-900 hover:text-amber-700', 'underline text-xs'])
        }, "Exit preview", 10, _hoisted_3)
      ], 2))
    : _createCommentVNode("", true)
}
}

})